import apiRequestType from "../../apiRequestType";
import { apiConstants } from "../../../utils/apiConstants";
import { apiTypes } from "../../../utils/apiTypes";
import { getAxiosCancelToken } from "../../../utils/getAxiosCancelToken";

let cancelToken;

const getClassesWithSurvey = (isScoredSurvey) => {
  cancelToken = getAxiosCancelToken(cancelToken);
  return apiRequestType(
    apiTypes.GET,
    apiConstants.REPORT.SURVEY_REPORT.GET_CLASS_WITH_SURVEY(isScoredSurvey),
    cancelToken
  );
};

export default getClassesWithSurvey;
